/**
 * Where the logo sits on the shared receipt PDF: centered above the business
 * name in a 180 × 72 box, 10 below to the name, on the 380-wide page — the
 * composition the owner sees in the business-details preview. The web PDF
 * page is 288 wide, so it scales the box with the page to keep the look.
 */
export const RECEIPT_PDF_PAGE_WIDTH = 380;
export const RECEIPT_PDF_LOGO_BOX = { width: 180, height: 72, gap: 10 };

/**
 * Scale `width` × `height` to fit a box, keeping the aspect ratio; small images
 * scale up to fill it, like `object-fit: contain` and Cloudinary's c_fit.
 */
export function fitInto(
  width: number,
  height: number,
  boxWidth: number,
  boxHeight: number,
): { width: number; height: number } {
  const scale = Math.min(
    boxWidth / Math.max(1, width),
    boxHeight / Math.max(1, height),
  );
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
}
